export const serverHost = process.env.REACT_APP_PYTHON_SERVER;

export const createEndpoints = ({
  setExtensionList,
  setBridgeList,
  setVoicemailList,
  setFlowsList,
  setIVRList,
  setTCList,
  setDestList,
  setRingGroup,
  setDomainList,
  site_uuid = null
}) => ({
  extensions: {
    url: `${serverHost}/get_rows?table=v_extensions&pageSize=500&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
    map: (e) => ({
      extension_uuid: e.extension_uuid,
      name: e.extension,
      accountcode: e.accountcode,
    }),
    setter: setExtensionList,
  },
  bridges: {
    url: `${serverHost}/get_rows?table=v_bridges&pageSize=500&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
    map: (b) => ({
      destination: b.bridge_destination,
      bridge_uuid: b.bridge_uuid,
      name: b.bridge_name,
    }),
    setter: setBridgeList,
  },
  voicemails: {
    url: `${serverHost}/fetch_voicemails/${encodeURIComponent(site_uuid)}`,
    map: (r) => ({
      voicemail_uuid: r.voicemail_uuid,
      voicemail_id: r.voicemail_id,
      value: `*99${r.voicemail_id} XML ${r.domain_name}`,
    }),
    setter: setVoicemailList,
  },
  flows: {
    url: `${serverHost}/get_rows?table=v_call_flows&pageSize=500&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
    map: (f) => ({
      value: `${f.call_flow_extension} XML ${f.call_flow_context}`,
      name: `${f.call_flow_extension} ${f.call_flow_name}`,
    }),
    setter: setFlowsList,
  },
  ivr: {
    url: `${serverHost}/get_rows?table=v_ivr_menus&pageSize=500&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
    map: (v) => ({
      value: v.ivr_menu_uuid,
      transfer: `${v.ivr_menu_extension} XML ${v.ivr_menu_context}`,
      name: v.ivr_menu_name,
    }),
    setter: setIVRList,
  },
  time_conditions: {
    url: `${serverHost}/fetch_time_conditions/${encodeURIComponent(site_uuid)}`,
    map: (tc) => ({
      value: `${tc.dialplan_number} XML ${tc.dialplan_context}`,
      name: `${tc.dialplan_number} ${tc.dialplan_name}`,
    }),
    setter: setTCList,
  },
  destinations: {
    url: `${serverHost}/fetch_destinations/${encodeURIComponent(site_uuid)}`,
    map: (d) => ({
      value: `${d.destination_number} XML ${d.destination_context}`,
      name: `${d.destination_number}${
        d.destination_description ? " " + d.destination_description : ""
      }`,
    }),
    setter: setDestList,
  },
  ringgroups: {
    url: `${serverHost}/get_rows?table=v_ring_groups&pageSize=500&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
    map: (r) => ({
      value: `${r.ring_group_extension} XML ${r.ring_group_context}`,
      name: `${r.ring_group_extension} ${r.ring_group_name}`,
    }),
    setter: setRingGroup,
  },
  domains: {
    url: `${serverHost}/get_rows?table=v_domains&pageSize=500&page=1&domain_uuid=${encodeURIComponent(site_uuid)}`,
    map: (d) => ({
      value: d.domain_uuid,
      name: d.domain_name,
    }),
    setter: setDomainList,
  },
});
